interface PaginationProps {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  disabled?: boolean;
  className?: string;
}

export function Pagination({ page, totalPages, onPageChange, disabled, className = '' }: PaginationProps) {
  return (
    <div className={`flex items-center justify-between border-t border-neutral-100 px-4 py-3 ${className}`}>
      <button
        className='rounded-md border border-neutral-200 px-3 py-2 text-sm text-neutral-700 disabled:cursor-not-allowed disabled:opacity-50'
        disabled={disabled || page <= 1}
        onClick={() => onPageChange(Math.max(page - 1, 1))}
        type='button'
      >
        Previous
      </button>
      <span className='text-sm text-neutral-600'>
        Page {page} of {totalPages}
      </span>
      <button
        className='rounded-md border border-neutral-200 px-3 py-2 text-sm text-neutral-700 disabled:cursor-not-allowed disabled:opacity-50'
        disabled={disabled || page >= totalPages}
        onClick={() => onPageChange(page + 1)}
        type='button'
      >
        Next
      </button>
    </div>
  );
}
